import { render } from "./info-modal.vue?vue&type=template&id=2a603ee0&scoped=true"
import script from "./info-modal.vue?vue&type=script&lang=js"
export * from "./info-modal.vue?vue&type=script&lang=js"

import "./info-modal.vue?vue&type=style&index=0&id=2a603ee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a603ee0"]])

export default __exports__